import { ReactKeycloakProvider } from "@react-keycloak/web";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { WagmiProvider } from "wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConnectKitProvider } from "connectkit";
import { config } from "./config/wagmi";
import Loader from "./components/loader/Loader";
import { AppContextProvider } from "./context/app-context";
import ErrorBoundary from "./pages/error-boundary/ErrorBoundary";
import keycloak from "./resources/keycloak";
import { routeMapper } from "./resources/route-mapper";
import {
  getAccessToken,
  getRefreshToken,
  setTokens,
} from "./utils/token-functions";

function App() {
  const router = createBrowserRouter(routeMapper);

  const queryClient = new QueryClient();

  return (
    <ErrorBoundary>
      <ReactKeycloakProvider
        authClient={keycloak}
        autoRefreshToken={true}
        initOptions={{
          token: getAccessToken(),
          refreshToken: getRefreshToken(),
          checkLoginIframe: false,
          onLoad: "check-sso",
          silentCheckSsoRedirectUri:
            window.location.origin + "/silent-check-sso.html",
          pkceMethod: "S256",
          loadUserProfileAtStartUp: true,
        }}
        LoadingComponent={<Loader isFullScreen={true} isLoading={true} />}
        onTokens={(tokens) => {
          setTokens(tokens.token ?? "", tokens.refreshToken ?? "");
        }}
      >
        <AppContextProvider>
          <WagmiProvider config={config}>
            <QueryClientProvider client={queryClient}>
              <ConnectKitProvider debugMode>
                <RouterProvider router={router} />
              </ConnectKitProvider>
            </QueryClientProvider>
          </WagmiProvider>
          <ToastContainer position="top-center" limit={2} />
        </AppContextProvider>
      </ReactKeycloakProvider>
    </ErrorBoundary>
  );
}

export default App;
